import React from 'react'

import icon_addVideo from '../i/add_video.svg'

/**
 * Youtube video
 */
class Block5 extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        const { embedCode, t } = this.props
        // return <div
        //     className={`block __${t}`}
        //     dangerouslySetInnerHTML={{ __html: embedCode }}>
        //     </div>
        return (
            <div className={`block __${t}`}>
                <img className="ico" src={icon_addVideo}></img>Video visible in preview or published mode
            </div>
        )
    }
}

export default Block5
